import React from "react";

export default function LadyStyle() {
  return (
    <div className="mb-8">
      <section className="space-y-2 m-auto text-zinc-600 text-center  mt-28 ">
        <h1 className="text-amber-600 font-bold">Lady style</h1>
        <h2>Qu’est-ce-que le Lady Styling? </h2>
        <img
          src="/img/ladyS.jpg"
          className="m-auto  h-96 rounded shadow object-contain"
          alt=""
        />
        <p className="px-4">
          Travail du style, de la{" "}
          <strong className="text-amber-600 text-xl font-bold">grâce</strong>,
          de{" "}
          <strong className="text-amber-600 text-xl font-bold">
            l’élégance
          </strong>{" "}
          et
          <br />
          des attitudes variées que l’on peut apporter à sa danse.{" "}
        </p>
        <br />
        <h2>Pour qui ? </h2>
        <p className="px-4">
          Il s’agit d’une discipline chorégraphique qui s’adresse à toutes les
          danseuses ! <br />
          A celles qui s’ignorent et qui n’ont jamais osé pousser la porte d’une
          salle de danse, <br />
          comme aux danseuses plus chevronnées qui cherchent un cours
          chorégraphique à forte influence latine.{" "}
        </p>

        <br />

        <div className="bg  py-8">
          <h1 className="my-16 text-center text-white">Objectifs :</h1>
          <div className=" flex flex-wrap justify-center m-auto items-start md:space-x-16 mx-4 space-y-8  mb-16">
            <div className="hidden"></div>
            <div className="container   flex-col  shado rounded p-4 md:w-1/6">
              <h1 className="text-rose-300">Féminité</h1>
              <div className="">
                <p className="pw">
                  <br /> <hr className=" mb-8" />
                  Se sentir{" "}
                  <strong className="text-rose-300 font-bold text-xl drop-shadow-sm">
                    Belle
                  </strong>{" "}
                  et{" "}
                  <strong className="text-rose-300 font-bold text-xl drop-shadow-sm">
                    féminine
                  </strong>{" "}
                  en dansant, même sur{" "}
                  <strong className="text-rose-300 font-bold text-xl drop-shadow-sm">
                    des pas de base
                  </strong>
                  .{" "}
                </p>{" "}
              </div>
            </div>

            <div className="container flex-col  shado rounded p-4 md:w-1/6">
              <h1 className="text-blue-200">Ecoute</h1>
              <div className="">
                <p className="pw">
                  <br /> <hr className="mb-8" />
                  Être à{" "}
                  <strong className="text-blue-200 font-bold text-xl drop-shadow-sm">
                    l’écoute
                  </strong>{" "}
                  de son propre{" "}
                  <strong className="text-blue-200 font-bold text-xl drop-shadow-sm">
                    corps
                  </strong>
                  , prendre{" "}
                  <strong className="text-blue-200 font-bold text-xl drop-shadow-sm">
                    confiance en soi
                  </strong>{" "}
                  et savoir quoi faire pour{" "}
                  <strong className="text-blue-200 font-bold text-xl drop-shadow-sm">
                    gagner en allure
                  </strong>
                  .
                </p>{" "}
              </div>
            </div>

            <div className=" container flex-col  shado  rounded p-4 md:w-1/6">
              <h1 className="">Se reveler</h1>
              <div className="content-wrapper">
                <p className="hidden-content pw">
                  <br /> <hr className="mb-8" />
                  <strong className="text-yellow-200 font-bold text-xl drop-shadow-sm">
                    Révéler
                  </strong>{" "}
                  et{" "}
                  <strong className="text-yellow-200 font-bold text-xl drop-shadow-sm">
                    développer
                  </strong>{" "}
                  son propre{" "}
                  <strong className="text-yellow-200 font-bold text-xl drop-shadow-sm">
                    style
                  </strong>
                  .{" "}
                </p>{" "}
              </div>
            </div>
          </div>
        </div>

        <div className="text-center space-y-4 px-4 pt-16">
          <h2 className="">Contenu des cours :</h2>
         
          <p>
            Postures du corps, des bras, des épaules…. savoir se positionner
            dans l’espace
          </p>
          <p> Isolation, dissociation et coordination haut et bas du corps</p>
          <p>
            Apprentissage ou révision des pas de base et découverte de nouveaux
            pas (shines)
          </p>
          <p>Développement du style sur de petites chorégraphies</p>
          <p>
            Technique de tour (spot), travail de l’équilibre et de la maîtrise
            de l’élan
          </p>
          <p>Savoir quoi faire et à quel moment, en solo ou en couple. </p>
        </div>

        <h1 className="py-16 px-4 ">
          Le premier pas est le plus important, je m'occupe du reste !
        </h1>

       
      </section>
    </div>
  );
}
